import { reqGetDelivTypes } from './GlobStateRequests'
import DelivTypeState from './DelivTypeState'
import withGlobalState from './WithGlobalState'
import SimpleSelect from 'components/SimpleSelect'
import { IUnControlledSelectProps } from './ISelect'

export default withGlobalState<IUnControlledSelectProps>(
  DelivTypeState,
  reqGetDelivTypes,
  SimpleSelect
)
